import React, { useEffect, useState } from 'react'
import Label from 'components/common/Label'
import { Select } from 'components/common/Select'
import { Autocomplete, TextField } from '@mui/material'

const YearOfBirth = ({ selectedYear = '', setSelectedYear, setChecked, checked }) => {
    const [years, setYears] = useState([])
    const [value, setValue] = useState('')

    // Generate a list of years from 1900 to the current year
    const generateYearList = () => {
        const currentYear = new Date().getFullYear()
        const years = []
        for (let i = currentYear; i >= 1900; i--) {
            years.push({ label: i.toString(), value: i })
        }
        return years
    }
    useEffect(() => {
        setYears(generateYearList())
    }, [])

    useEffect(() => {
        if (selectedYear) {
            setValue(years.find(el => el.value === selectedYear))
        } else {
            setValue('')
        }
    }, [selectedYear])

    return (
        <div>
            <p
                style={{
                    fontWeight: '700',
                    paddingBottom: 12,
                }}
            >
                What’s your year of birth?
            </p>
            <Autocomplete
                disablePortal
                id="yearOfBirth"
                style={{
                    border: 'none',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    marginBottom: 16,
                }}
                options={years}
                onChange={(_, newValue) => {
                    setSelectedYear(newValue.value)
                    setChecked(false)
                }}
                value={value}
                onSelect={() => setChecked(false)}
                renderInput={params => (
                    <TextField
                        {...params}
                        placeholder={!selectedYear ? 'e.g. 1980' : ''}
                        inputProps={{ ...params.inputProps, style: { fontSize: 16 } }}
                    />
                )}
            />
        </div>
    )
}

export default YearOfBirth
